const myFields = [
  {
    name: 'Milho',
    color: 'blue',
    fillColor: 'blue',
    positions: [
      {
        lat: -23.18986774534026,
        lng: -47.18888531569974,
      },
      {
        lat: -23.189966365300332,
        lng: -47.188048466487096,
      },
      {
        lat: -23.190143881045213,
        lng: -47.18691120986479,
      },
      {
        lat: -23.19038056833853,
        lng: -47.18570958022612,
      },
      {
        lat: -23.190636979100304,
        lng: -47.184550865931676,
      },
      {
        lat: -23.190735598493156,
        lng: -47.184078797145055,
      },
      {
        lat: -23.190558083533656,
        lng: -47.18388567809598,
      },
      {
        lat: -23.18714580574231,
        lng: -47.18242655639188,
      },
      {
        lat: -23.186849939404944,
        lng: -47.18249092940824,
      },
      {
        lat: -23.186554072413173,
        lng: -47.18302737121122,
      },
      {
        lat: -23.186337102869967,
        lng: -47.18392859344022,
      },
      {
        lat: -23.18641600092639,
        lng: -47.18513022307889,
      },
      {
        lat: -23.186928837158884,
        lng: -47.1864820564224,
      },
      {
        lat: -23.187540293174155,
        lng: -47.187275990290814,
      },
      {
        lat: -23.188210919138246,
        lng: -47.18813429717558,
      },
    ],
  },
  {
    name: 'Feijão',
    color: 'red',
    fillColor: 'red',
    positions: [
      {
        lat: -23.186901429536817,
        lng: -47.182178539806046,
      },
      {
        lat: -23.187295917689358,
        lng: -47.181148571544334,
      },
      {
        lat: -23.187986269156866,
        lng: -47.180225891643204,
      },
      {
        lat: -23.18920916872458,
        lng: -47.17953924613539,
      },
      {
        lat: -23.189702270225805,
        lng: -47.17932466941421,
      },
      {
        lat: -23.19084625870723,
        lng: -47.17921738105361,
      },
      {
        lat: -23.191556315601545,
        lng: -47.17926029639785,
      },
      {
        lat: -23.192384710546737,
        lng: -47.17951778846328,
      },
      {
        lat: -23.192660841054803,
        lng: -47.179625076823875,
      },
      {
        lat: -23.19076736326405,
        lng: -47.18395952659194,
      },
    ],
  },
  {
    name: 'Tomate',
    color: 'lime',
    fillColor: 'lime',
    positions: [
      {
        lat: -23.189912675095837,
        lng: -47.188828584621675,
      },
      {
        lat: -23.192141467695045,
        lng: -47.188635465572595,
      },
      {
        lat: -23.19324598831536,
        lng: -47.18797027773691,
      },
      {
        lat: -23.193916585669676,
        lng: -47.187176343868494,
      },
      {
        lat: -23.194567456356317,
        lng: -47.18608200259042,
      },
      {
        lat: -23.194863305621116,
        lng: -47.18509494967294,
      },
      {
        lat: -23.19502109162803,
        lng: -47.18374311632943,
      },
      {
        lat: -23.194863305621116,
        lng: -47.18249857134652,
      },
      {
        lat: -23.19452800973822,
        lng: -47.181382772396326,
      },
      {
        lat: -23.1940546494134,
        lng: -47.18073904223275,
      },
      {
        lat: -23.19346294665094,
        lng: -47.18003093905282,
      },
      {
        lat: -23.19261483479225,
        lng: -47.179687616298914,
      },
      {
        lat: -23.19076080409109,
        lng: -47.18395769305063,
      },
      {
        lat: -23.19014936279834,
        lng: -47.18676864809823,
      },
    ],
  },
];

export { myFields };
